
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { dashedVid } from '@/utils/index'
@Component({
  components: {},
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop({ default: '' }) private certUrl!: string
  @Prop({ default: '' }) private vid!: string
  @Prop({ default: '' }) private cid!: string
  
  /// data
  private data: Object = {}
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }

  private openVerification() {
    //  this.certUrl && window.open(this.certUrl)
    this.$router.push({path:'cert'})
  }

  private get vidDescribe(): string {
      if(!this.cid){
        return  dashedVid(this.vid)
      }else{
         return dashedVid(this.cid)
      }
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
